var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-up" } }, [
    _c("div", { staticClass: "sliding-panel" }, [
      _c(
        "div",
        { staticClass: "sliding-panel-header" },
        [
          _c("IconUserList"),
          _vm._v(" "),
          _c("div", { staticClass: "sliding-panel-title" }, [
            _c("h6", [
              _vm._v(_vm._s(_vm.$t("message.preferredRepresentative"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "arrow-wrapper", on: { click: _vm.closePanel } },
            [
              _c("md-icon", { staticClass: "arrow-button" }, [
                _vm._v("keyboard_arrow_down"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "search-bar-wrapper" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchQuery,
              expression: "searchQuery",
            },
          ],
          staticClass: "search-bar",
          attrs: {
            type: "text",
            placeholder: _vm.$t("message.searchRepresentative"),
          },
          domProps: { value: _vm.searchQuery },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchQuery = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "search-icon" },
          [_c("md-icon", [_vm._v("search")])],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agent-list" },
        _vm._l(_vm.filteredAgents, function (agent) {
          return _c("div", { key: agent._id, staticClass: "agent-item" }, [
            _c(
              "span",
              {
                staticClass: "agent-name",
                on: {
                  click: function ($event) {
                    return _vm.toggleAgent(agent)
                  },
                },
              },
              [_vm._v(_vm._s(agent.name))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedAgents,
                  expression: "selectedAgents",
                },
              ],
              staticClass: "checkbox",
              attrs: { type: "checkbox" },
              domProps: {
                value: agent._id,
                checked: Array.isArray(_vm.selectedAgents)
                  ? _vm._i(_vm.selectedAgents, agent._id) > -1
                  : _vm.selectedAgents,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.selectedAgents,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = agent._id,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectedAgents = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectedAgents = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectedAgents = $$c
                  }
                },
              },
            }),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }